import { sendEmailScoreCard } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailScoreCard);
};
export default useSendEmail;
